import { DomEventHost } from '@amzn/vinyl-util'
import { isHidden } from '@amzn/shiv'

export const windowEvents = new DomEventHost<WindowEventMap>(window)
export const documentEvents = new DomEventHost<DocumentEventMap>(document)

export const tabbableQuery = `
  a[href]:not([tabindex="-1"]),
  button:not([disabled]):not([tabindex="-1"]),
  input:not([disabled]):not([tabindex="-1"]),
  textarea:not([disabled]):not([tabindex="-1"]),
  select:not([disabled]):not([tabindex="-1"]),
  details:not([tabindex="-1"]),
  [tabindex]:not([tabindex="-1"]),
  [contenteditable="true"]
`

/**
 * Returns a list of the current visible focusables.
 */
export function getFocusables(): readonly HTMLElement[] {
    return Array.from(document.querySelectorAll<HTMLElement>(tabbableQuery)).filter(
        (e) => !isHidden(e)
    )
}
